import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';
import AuctioneerDashboard from '../components/AuctioneerDashboard';
import CreateAuctionForm from '../components/CreateAuctionForm';

export default function AuctioneerPage() {
  const { user, logout } = useAuth();
  const [auctions, setAuctions] = useState<any[]>([]);
  const [view, setView] = useState<'list' | 'create'>('list');

  useEffect(() => {
    loadAuctions();
  }, []);

  async function loadAuctions() {
    const { data } = await api.get('/auctions');
    setAuctions(data);
  }

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <h2 style={{ margin: 0 }}>Auction Platform — Auctioneer</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span>{user?.name}</span>
          <button style={styles.logoutBtn} onClick={logout}>Logout</button>
        </div>
      </header>
      <div style={styles.content}>
        <div style={styles.toolbar}>
          <button style={view === 'list' ? styles.activeBtn : styles.btn} onClick={() => setView('list')}>My Auctions</button>
          <button style={view === 'create' ? styles.activeBtn : styles.btn} onClick={() => setView('create')}>+ New Auction</button>
        </div>
        {view === 'create' && (
          <CreateAuctionForm onCreated={() => { loadAuctions(); setView('list'); }} />
        )}
        {view === 'list' && (
          <AuctioneerDashboard auctions={auctions} onRefresh={loadAuctions} />
        )}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: '100vh', background: '#f0f2f5' },
  header: { background: '#1a1a2e', color: 'white', padding: '1rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  content: { padding: '2rem' },
  toolbar: { display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' },
  btn: { padding: '0.5rem 1rem', border: '1px solid #ddd', background: 'white', borderRadius: '4px', cursor: 'pointer' },
  activeBtn: { padding: '0.5rem 1rem', border: '1px solid #4a90e2', background: '#4a90e2', color: 'white', borderRadius: '4px', cursor: 'pointer' },
  logoutBtn: { padding: '0.4rem 0.8rem', background: 'transparent', border: '1px solid white', color: 'white', borderRadius: '4px', cursor: 'pointer' },
};
